import React, { FC, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { Row, Col, Button, Dropdown, Menu, Image } from "antd";
import { SearchOutlined, CheckOutlined } from "@ant-design/icons";
import MapPreview from "./MapPreview";
import {
  RSVPRespModal,
  RxSensorTableModal,
  CameraVideoModal,
  EditPaymentModal,
} from "components/Modals";
import MapPreviewModal from "components/Modals/MapPreviewModal";
import AddEventModal from "components/Modals/AddEventModal";
import { useDispatch, useSelector } from "react-redux";
import MapService from "../MapPanel/MapService";
import moment from "moment";
import {
  getTwilioRecordedVideoRecordingPublishTopic,
  getTwilioRecordedVideoSubscriptionTopic,
} from "hooks/MQTTConstants";
import { RootState } from "reducers/rootReducer";
import { MapTopics, SocketTopics } from "../../../constants/enums";
import VideoPlayerModal from "components/Modals/VideoPlayerModal";
import { useEventSubscriber } from "utils/event";
import { popupCenter } from "utils/appUtil";

const MessageItem: FC<{
  screens: ScreenStateObj;
  setScreens: React.Dispatch<React.SetStateAction<ScreenStateObj>>;
  socket: ISocket;
  message: MessageObj;
  onMessageVisible: () => void;
  onEdit: (message: MessageObj) => void;
  onRemove: (message: MessageObj) => void;
  page: SelectedSearchItem | undefined;
  readBy: SelectedSearchItem[] | undefined;
  onEvent: (event: string, mode?: any) => void;
}> = ({
  screens,
  setScreens,
  socket,
  message,
  onMessageVisible,
  onEdit,
  onRemove,
  page,
  readBy,
  onEvent,
}) => {
  const { allUsers } = useSelector((state: RootState) => state.auth);
  // const { focusMessage } = useSelector((state: RootState) => state.message);
  const [rsvpModalOpen, setRSVPModalOpen] = useState<boolean>(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState<boolean>(false);
  const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
  const [rxSensorDevice, setRxSensorDevice] = useState<boolean>(false);
  const [cameraVideo, setCameraVideo] = useState<boolean>(false);
  const [lastSeen, setLastSeen] = useState<string | undefined>();
  const [username, setUsername] = useState<string | undefined>(
    message.senderName
  );
  const [userProfileImage, setUserProfileImage] = useState<any>(
    "/images/users/user.png"
  );
  const { showGPSHistorical } = MapService();
  const subscriber = useEventSubscriber(message.id, (event) => {
    handleIconClick();
  });

  useEffect(() => {
    const userId: string | undefined = message.senderName?.split("# ")[1];
    const user = allUsers?.find((obj) => obj.id === userId);
    if (user?.beamId) {
      setUsername(user?.beamId);
    } else {
      setUsername(message.senderName);
    }
    setUserProfileImage(
      user?.profileImage?.urls?.original?.url ?? "/images/users/user.png"
    );
    onMessageVisible();
  }, [message.senderName, allUsers]);

  useEffect(() => {
    let read = page?.readBy?.[parseInt(message.id.toString())] ?? undefined;
    if (read && read.length > 0) {
      let seen = "Read by ";
      read = read.filter((x) => {
        return x !== localStorage.getItem("RID");
      });
      read.map((x, index) => {
        const user = allUsers?.find((obj) => obj.id === x);
        seen =
          seen +
          (user?.beamId || `user# ${x}`) +
          (index !== read.length - 1 ? ", " : "");
      });
      if (read.length > 0) {
        setLastSeen(seen);
      }
    } else {
      setLastSeen(undefined);
    }
  }, [page, allUsers]);

  const dispatch = useDispatch();
  const infoMenu = (message) => (
    <div className="menu-container">
      <div className="menu-item">
        <ReactSVG src="/images/gps-icon.svg" />
        <p>{JSON.stringify(message.data?.coordinates)}</p>
      </div>
      <div className="menu-item">
        <ReactSVG src="/images/geolocation-icon.svg" />
        <p>{message.data?.attributes?.address ?? "N/A"}</p>
      </div>
    </div>
  );

  const editMenu = (
    <div className="menu-container edit-menu">
      <div
        className="menu-item"
        onClick={() => {
          if (
            message.messageType === "text" ||
            message.messageType === "media"
          ) {
            onEdit(message);
          } else if (message.messageType === "place") {
            dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
            socket.subscribeToEvent(
              SocketTopics.SubscribePageTopics,
              // MapTopics.FocusMap
              `${
                process.env.REACT_APP_ECO_SYSTEM
              }/connection/${localStorage.getItem(
                "CID"
              )}/connection/${localStorage.getItem("CID")}/focusMap`
            );
            socket.publishToEvent(
              SocketTopics.PublishPageTopics,
              // MapTopics.FocusMap,
              `${
                process.env.REACT_APP_ECO_SYSTEM
              }/connection/${localStorage.getItem(
                "CID"
              )}/connection/${localStorage.getItem("CID")}/focusMap`,
              {
                type: "ADD_SELECTED_PLACES",
                payload: {
                  ...message,
                  id: message.id,
                  name: message.message,
                  objectType: "place",
                },
              }
            );
            socket.publishToEvent(
              SocketTopics.PublishPageTopics,
              // MapTopics.FocusMap,
              `${
                process.env.REACT_APP_ECO_SYSTEM
              }/connection/${localStorage.getItem(
                "CID"
              )}/connection/${localStorage.getItem("CID")}/focusMap`,
              {
                type: "EDIT_PLACE",
                payload: {
                  id: message.id,
                  type: message?.data?.display?.type,
                },
              }
            );

            return;
          } else if (message.messageType === "event") {
            onEvent("event", "edit");
          } else if (message.messageType === "pay") {
            onEvent("pay", "edit");
          }
        }}
      >
        <p>Edit</p>
      </div>
      {/* <div className="menu-item">
        <p>Copy</p>
      </div>
      <div className="menu-item">
        <p>Quote</p>
      </div>
      <div className="menu-item">
        <p>Forward</p>
      </div>
      <div className="menu-item">
        <p>Collaborate</p>
      </div>
      <div className="menu-item">
        <p>Bookmark</p>
      </div> */}

      <div
        className="menu-item"
        onClick={() => {
          onRemove(message);
        }}
      >
        <p>Remove</p>
      </div>
    </div>
  );

  const seenByMenu = () => {
    let read = page?.readBy?.[parseInt(message.id.toString())] ?? undefined;
    // let read = ["20420", "32343", "32346"];
    let readUserName = [];
    if (read && read.length > 0) {
      read = read.filter((x) => {
        return x !== localStorage.getItem("RID");
      });
      read.map((x, index) => {
        const user = allUsers?.find((obj) => obj.id === x);
        readUserName.push({
          beamId: user?.beamId || `user# ${x}`,
          profileImage:
            user?.profileImage?.urls?.original?.url ?? "/images/users/user.png",
        });
      });
    }

    return (
      <div className="menu-container seen-by-container edit-menu">
        <div className="mb-3">
          <h6>Read by</h6>
        </div>

        {readUserName.map((user) => (
          <Row className="mb-2 align-items-center">
            {/* <p>{username}</p> */}

            <Col span={4}>
              <img
                src={user.profileImage}
                width="25"
                height="25"
                style={{ borderRadius: "50%" }}
              />
            </Col>

            <Col span={13}>
              <p>{user.beamId}</p>
            </Col>
          </Row>
        ))}
      </div>
    );
  };

  const handleIconClick = () => {
    console.log("handle message", message);
    if (message.messageType === "rsvp") {
      setRSVPModalOpen(true);
      return;
    }
    if (message.messageType === "pay" && (!message.data?.status || message.data?.status  !== "succeeded")) {
      setPaymentModalOpen(true);
      return;
    }
    if (message.messageType === "place") {
      dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        // MapTopics.FocusMap
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        // MapTopics.FocusMap,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`,
        {
          type: "ADD_SELECTED_PLACES",
          payload: {
            ...message,
            id: message.id,
            name: message.message,
            objectType: "place",
          },
        }
      );
      return;
    }

    if (message.messageType === "event") {
      onEvent("event");
      return;
    }

    if (message.messageType === "alert-configuration") {
      onEvent("alert");
      return;
    }

    if (
      message.messageType === "gps-report" ||
      message.messageType === "alert"
    ) {
      dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
      showGPSHistorical(
        message,
        message.data.startIotAt,
        message.data.endIotAt
      );
    }

    if (message.messageType === "gps") {
      dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        // MapTopics.FocusMap
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        // MapTopics.FocusMap,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`,
        {
          type: "ADD_SELECTED_PLACES",
          payload: {
            ...message,
            id: message.id,
            name: message.message,
            objectType: "user",
          },
        }
      );
      return;
    }
    if (message.messageType === "video-recording") {
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getTwilioRecordedVideoSubscriptionTopic()
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getTwilioRecordedVideoRecordingPublishTopic(),
        {
          id: message.data.data?.id,
        }
      );
      return;
    }
    if (message.messageType === "rx") {
      setRxSensorDevice(true);
    }
    if (message.messageType === "summary") {
      window.open(message.data?.url, "_blank");
    }

    if (message.messageType === "survey") {
      popupCenter(
        `${process.env.REACT_APP_SHARED_URI}/survey?mode=edit&userId=${
          page?.persistent?.static?.iotAsset?.config?.configUserId
        }&surveyId=${message.data.surveyId}&type=survey&cudbServiceId=${
          page?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId
        }&connectionId=${localStorage.getItem(
          "CID"
        )}&liveUserId=${localStorage.getItem("RID")}&pageId=${page.pageId}`,
        "Survey",
        window.innerWidth * 0.7,
        window.innerHeight * 0.9
      );
    }

    if (message.messageType === "cam") {
      setCameraVideo(true);
    }

    if (message.messageType === "media") {
      if (message.data?.mimeType?.indexOf("video") !== -1) {
        setVideoPlayerOpen(true);
      } else {
        window.open(message.data.urls.original.url, "_blank");
      }
    }
    if (message.messageType === "sound-recording") {
      window.open(message.data?.data?.url, "_blank");
    }
  };
  // in case of new attributes, store them from useMQTTService()
  return (
    <React.Fragment>
      <div
        className={`${
          localStorage.getItem("RID") === message.senderId.toString()
            ? "message-div-right"
            : ""
        }`}
      >
        <div className={`message-item`} id={message?.id?.toString()}>
          <div className="user-info">
            <div className="d-flex">
              <img
                src={userProfileImage}
                className="user-avatar"
                style={{ borderRadius: "50%" }}
              />
              <h4>{username}</h4>
              <span>
                {message.originalCreatedAt
                  ? moment(message.originalCreatedAt).format("ddd DD HH:mm")
                  : moment(message.createdAt).format("ddd DD HH:mm")}
              </span>
            </div>
            <div className="d-flex">
              {message.messageType !== "text" &&
                message.messageType !== "info" &&
                message.messageType !== "rsvp-response" && (
                  <img
                    onClick={handleIconClick}
                    className="ml-2 message-type cursor-pointer"
                    src={`/images/${message.messageType}-icon.png`}
                  />
                )}
              {message.messageType === "place" && (
                <Dropdown
                  overlay={infoMenu(message)}
                  className="message-dropdown"
                  placement="bottomRight"
                >
                  <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Info
                  </a>
                </Dropdown>
              )}

              {message.senderId.toString() === localStorage.getItem("RID") && (
                <Dropdown
                  overlay={editMenu}
                  className="message-dropdown"
                  placement="bottomRight"
                >
                  <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Edit
                  </a>
                </Dropdown>
              )}
            </div>
          </div>

          {/* {(message.messageType !== "media" ||
            message.data?.mimeType?.indexOf("image") === -1) && (
            <p>{message.message}</p>
          )} */}
          <Row>
            <Col span={22}>
              <p>{message.message}</p>
            </Col>
            {localStorage.getItem("RID") === message.senderId.toString() && (
              <Col
                span={2}
                className="d-flex justify-content-end align-items-start"
              >
                <CheckOutlined style={{ color: "rgb(70 130 244)" }} />
              </Col>
            )}
          </Row>
          {message.messageType === "place" &&
            message.data?.attributes?.address && (
              <span className="sub-text">
                <p>Address: {message.data?.attributes?.address}</p>
              </span>
            )}

          {message.messageType === "pay" && (
            <React.Fragment>
              <span className="sub-text">
                <p>
                  Amount due ({message.data?.currency}): {message.data?.amount}
                </p>
              </span>
              <span className={message.data?.status === "succeeded" ? "paid": "unpaid"}>
                <p>{message.data?.status === "succeeded" ? "Paid": "Unpaid"}</p>
              </span>
            </React.Fragment>
          )}

          {message.messageType === "gps-report" && (
            <span className="sub-text">
              <p>
                Start date: {new Date(message.data.startIotAt).toLocaleString()}
              </p>
              <p>
                End date: {new Date(message.data.endIotAt).toLocaleString()}
              </p>
            </span>
          )}

          {message.messageType === "gps" && (
            <span className="live-mode">
              <p>Live Mode: on</p>
            </span>
          )}

          {message.messageType === "media" &&
            message.data?.mimeType?.indexOf("image") !== -1 && (
              <Image
                width={125}
                className={"mt-2"}
                src={message?.data?.urls?.original?.url}
              />
            )}
          {rsvpModalOpen && (
            <RSVPRespModal
              onClose={() => setRSVPModalOpen(false)}
              rsvp={message}
            />
          )}
          {paymentModalOpen && (
            <EditPaymentModal
              onClose={() => setPaymentModalOpen(false)}
              pay={message}
              socket={socket}
            />
          )}
          {rxSensorDevice && (
            <RxSensorTableModal
              onClose={() => setRxSensorDevice(false)}
              sensorObj={message}
              socket={socket}
            />
          )}
          {cameraVideo && (
            <CameraVideoModal
              onClose={() => setCameraVideo(false)}
              sensorObj={message}
              socket={socket}
            />
          )}
          {videoPlayerOpen && (
            <VideoPlayerModal
              url={message.data?.urls?.original?.url}
              onClose={() => setVideoPlayerOpen(false)}
            />
          )}
        </div>
      </div>

      {lastSeen && (
        <Dropdown
          overlay={seenByMenu()}
          trigger={["click"]}
          className="message-dropdown"
          placement="bottomRight"
        >
          <div
            className="message-seen-by"
            style={
              localStorage.getItem("RID") === message.senderId.toString()
                ? { width: "100%" }
                : {}
            }
          >
            <p>{lastSeen}</p>
          </div>
        </Dropdown>
      )}
    </React.Fragment>
  );
};

export default MessageItem;
